/* eslint-disable @typescript-eslint/naming-convention */

export enum FORM_ADVANCED_SECTIONS {
  sin = 'sin',
  ssn = 'ssn',
  canadianBank = 'canadianBank',
  americanBank = 'americanBank',
  addressValidator = 'completeAddress',
  emergencyContact = 'emergencyContact',
  fullName = 'fullName',
  documentPreview = 'documentPreview',
  miscellaneous = 'miscellaneous',
  signature = 'signature',
  earliestStartDate = 'earliestStartDate',
}
export const ACTIVE_ADVANCED_SECTIONS_KEYS = [
  FORM_ADVANCED_SECTIONS.sin,
  FORM_ADVANCED_SECTIONS.ssn,
  FORM_ADVANCED_SECTIONS.canadianBank,
  FORM_ADVANCED_SECTIONS.americanBank,
  FORM_ADVANCED_SECTIONS.addressValidator,
  FORM_ADVANCED_SECTIONS.emergencyContact,
  FORM_ADVANCED_SECTIONS.fullName,
];

export const SECTION_NAMES = {
  [FORM_ADVANCED_SECTIONS.canadianBank]: 'Canadian Bank',
  [FORM_ADVANCED_SECTIONS.americanBank]: 'American Bank',
  [FORM_ADVANCED_SECTIONS.emergencyContact]: 'Emergency Contact',
  [FORM_ADVANCED_SECTIONS.sin]: 'SIN',
  [FORM_ADVANCED_SECTIONS.ssn]: 'SSN',
  [FORM_ADVANCED_SECTIONS.fullName]: 'Full Name',
  [FORM_ADVANCED_SECTIONS.addressValidator]: 'Complete Address',
  [FORM_ADVANCED_SECTIONS.documentPreview]: 'Document Preview',
  [FORM_ADVANCED_SECTIONS.miscellaneous]: 'Miscellaneous',
  [FORM_ADVANCED_SECTIONS.signature]: 'Signature',
  [FORM_ADVANCED_SECTIONS.earliestStartDate]: 'Earliest Start Date',
};

export const ADVANCED_SECTION_TITLES = {
  [FORM_ADVANCED_SECTIONS.canadianBank]: { en: SECTION_NAMES.canadianBank, fr: 'Banque canadienne' },
  [FORM_ADVANCED_SECTIONS.americanBank]: { en: SECTION_NAMES.americanBank, fr: 'Banque américaine' },
  [FORM_ADVANCED_SECTIONS.emergencyContact]: { en: SECTION_NAMES.emergencyContact, fr: 'Contact d’urgence' },
  [FORM_ADVANCED_SECTIONS.sin]: { en: SECTION_NAMES.sin, fr: 'Numéro d’assurance sociale(NAS)' },
  [FORM_ADVANCED_SECTIONS.ssn]: { en: SECTION_NAMES.ssn, fr: 'Numéro de sécurité sociale(SSN)' },
  [FORM_ADVANCED_SECTIONS.addressValidator]: { en: SECTION_NAMES.completeAddress, fr: 'Adresse complète' },
  [FORM_ADVANCED_SECTIONS.fullName]: { en: SECTION_NAMES.fullName, fr: 'Nom complet' },
  [FORM_ADVANCED_SECTIONS.documentPreview]: { en: SECTION_NAMES.documentPreview, fr: 'Aperçu du document' },
  [FORM_ADVANCED_SECTIONS.miscellaneous]: { en: SECTION_NAMES.miscellaneous, fr: 'Divers' },
  [FORM_ADVANCED_SECTIONS.signature]: { en: SECTION_NAMES.signature, fr: 'Signature' },
  [FORM_ADVANCED_SECTIONS.earliestStartDate]: { en: SECTION_NAMES.earliestStartDate, fr: 'Date de début la plus proche' },
};

export const ACTIVE_ADVANCED_SECTIONS_TITLES = [
  ADVANCED_SECTION_TITLES.sin,
  ADVANCED_SECTION_TITLES.ssn,
  ADVANCED_SECTION_TITLES.canadianBank,
  ADVANCED_SECTION_TITLES.americanBank,
  ADVANCED_SECTION_TITLES.completeAddress,
  ADVANCED_SECTION_TITLES.emergencyContact,
  ADVANCED_SECTION_TITLES.fullName,
].flatMap((section) => Object.values(section));
